<script setup>
import { inject, ref } from 'vue';
import { vMaska } from 'maska/vue';
import { ErrorMessage, Field } from 'vee-validate';

import { __, updateURL, isNumber, setFormValues, clearDash, getAccountByNumber, handleNumberFieldPaste } from '@/utils';
import ModalDatepicker from './parts/modal-datepicker.vue';
import ModalOtp from './parts/modal-otp.vue';
import Loader from '@components/loader.vue';
import Modal from "@components/modal.vue";

const { form, meta, values: formValues } = inject('form');

const noneCustomer = ref(false);
const loading = ref(false);
const apiError = ref(false);
const showOTPPopup = ref(false);
const otpCode = ref('');
const values = ref([]);
const OTPphone = ref('');
 
const handleModalClose = () => {
	showOTPPopup.value = false;
	otpCode.value = '';
}

const handleModalSuccess = (value) => {
    setFormValues({
        roamingCustomerNumber: value,
    })

	showOTPPopup.value = false;
	form.value.requestSubmit();
}
updateURL('#step2');

const handleClick = async () => {
	loading.value = true;
	const phone = clearDash(formValues.roamingCustomerNumber);
	const response = await getAccountByNumber({
		code: '',
		msisdn: phone
	});
	loading.value = false;

	const responseObj = JSON.parse(response.data);
	
	if(!responseObj.response.status && responseObj.response.error === "subscriber_not_found") {
		noneCustomer.value = true;
	} else if(!responseObj.response.status && responseObj.response.error === "required_otp"){
		values.value.msisdn = phone
		showOTPPopup.value = true;
		const reponseTextObj = JSON.parse(responseObj.response['response-text']);
		OTPphone.value = reponseTextObj.phone_number;
	} 
}


</script>
<template>
    <div class="form__group">
        <header class="form__head">
            <h2>
                {{ __('Customer information') }}
            </h2>
        </header><!-- /.form__head-->

		<h6>{{ __('Select a departure date') }}</h6>

		<label>{{ __('Departure date') }} <img :src="`${theme_path.url}/resources/images/plane-regular.svg`" alt="Plane Icon"></label>
        <ModalDatepicker />

		<label for="field-fname"><strong>{{ __('* Phone number of the subscriber traveling') }}</strong></label>
		<div class="field field-roaming-phone-number">
			<ErrorMessage as="span" class="field__error" name="roamingCustomerNumber" />

			<Field 
				type="text"
				name="roamingCustomerNumber"
				id="field-fname"
				v-maska
				data-maska="05#-##########"
				@keypress="isNumber($event)"
				maxlength="11"
				@paste="handleNumberFieldPaste"
			/>
			<img :src="`${theme_path.url}/resources/images/svg/smartphone.svg`" alt="Smartphone Icon">
		</div>

		<ModalOtp 
			class="popup--roaming-steps"
			:showOTPPopup="showOTPPopup" 
			:handleModalClose="handleModalClose"
			:values="values"
			:OTPphone="OTPphone"
			@error="apiError = true"
			@success="handleModalSuccess"
		>
			<template #actions>
				<button type="button" class="link-underline" @click="handleModalClose">{{ __('cancellation') }}</button>
			</template>
		</ModalOtp>

		<Modal
			class="popup--none-customer"
			:isActive="noneCustomer"
			@close="noneCustomer = false"
		>
			<template #body>
				<p>{{ __('Not our customers yet?') }}<br/>
				<strong>{{ __('Join XPhone now and stop paying a fortune for surfing abroad') }}</strong></p>
			</template>
			<template #foot>
				<div class="mb20">
					<a href="/" class="btn btn--fullwidth">{{ __('to join online') }} >></a>
				</div>
				<div>
					<a href="tel:*0018" class="btn btn--fullwidth btn--black">{{ __('To join through a representative') }} 0018*</a>
				</div>
			</template>
		</Modal>
			
    </div><!-- /.form__group -->
	<div class="form__actions" v-if="meta.valid">
		<button type="button" class="btn btn--arrows" @click="handleClick">
			<Loader color="#fff" v-if="loading" />
			{{ __('Continued')}}
		</button>
	</div>
</template>